module.exports = __webpack_public_path__ + "41bc4dfc635786dd51184727df103bb8.pdf";